export default __webpack_public_path__ + "static/media/PolygonPhygital.dc0c10af.mp4";